import { Button, styled } from "@mui/material";

export const SquareButton = styled(Button)(() => ({
  padding: "10px 50px",
  borderRadius: 0,
}));
